// extracted by mini-css-extract-plugin
export default {"minus-button":"styles__minus-button--2bj1l","plus-button":"styles__plus-button--YTGRv","input-with-buttons-on-right":"styles__input-with-buttons-on-right--piO8x"};